<template>
    <span>
        <div class="main-box" :id="`event-${bang.id}`">
            <div class="photo bang" :style="{'background': `url(${bang.photo_orig}) no-repeat center / cover`}"></div>
            <div class="main-box-footer">
                <div class="inner">
                  <div class="info">
                      <div class="name bang">
                          {{ bang.title }}
                      </div>
                  </div>
                  <div class="details bang">
                      <div class="row first">
                          <div class="detail date">{{ bang.event_date | formatDate('day-date') }}</div>
                          <div class="detail location notranslate">{{ bang.address_type == 'city_only' || bang.type == 'fun' || bang.type == 'bang' ? (bang.country_code && bang.country_code.toLowerCase() === 'us' ? bang.locality + ', ' +bang.state : bang.locality) : bang.address }}</div>
                      </div>
                      <div class="row second">
                          <div class="detail time">{{ bang.time }}</div>
                          <div class="detail group">{{ bang.members_count }}</div>
                      </div>
                      <div class="description" v-if="bang.type !== 'guide'">{{ bang.description }}</div>
                      <div class="description" v-else v-html="bang.description"></div>
                  </div>
                </div>

                <div class="favorites" v-if="members && membersCount">
                    <div class="faces">
                      <div class="face"
                           v-if="members.length && members[0].id === bang.user_id"
                           @click="openUser(members[0])"
                           :class="{'host': ((bang.membership === 'host' && members[0].id === bang.user_id) || members[0].membershipStatus === 'host'), 'meet_now': members[0].meet_now,  'online': members[0].isOnline, 'was-online': members[0].wasRecentlyOnline && !members[0].isOnline, 'pending': members[0].membershipStatus === 'requested'}">
                            <div class="img"
                                 :class="{'is-deleted': !!members[0].deleted_at}"
                                 :style="!members[0].deleted_at && {'background': `url(${members[0].photo_small}) no-repeat center / cover`}">
                            </div>
                            <div class="details">
                                <div class="name notranslate">{{ members[0].headline }}</div>
                            </div>
                        </div>
                        <div class="add-private-member face" @click="openPrivateInvite()" v-if="bang.membership === 'host'">
                          <img src="/main/img/icons/add.svg">
                        </div>
                        <div class="face"
                             v-for="user in invitedUsers.filter(v => v.membershipStatus === 'invited')"
                             @click="openUser(user)"
                             :class="{'pending-wait':true, 'meet_now': user.meet_now,'online': user.isOnline, 'was-online': user.wasRecentlyOnline && !user.isOnline}">
                            <div class="img"
                                :class="{'is-deleted': !!user.deleted_at}"
                                :style="!user.deleted_at && {'background': `url(${user.photo_small}) no-repeat center / cover`}">
                            </div>
                            <div class="close"
                                 v-if="bang.membership === 'host' && user.id !== bang.user_id"
                                 @click.stop="deleteInvitation({ eventId: eventIdComputed, user_id:user.id})">
                            </div>
                            <div class="details">
                                <div class="name notranslate">{{ user.headline }}</div>
                            </div>
                        </div>
                      <div class="face"
                           v-for="user in members"
                           v-if="user.membershipStatus === 'requested'"
                           @click="openUser(user)"
                           :class="{'online': user.isOnline, 'meet_now': user.meet_now, 'was-online': user.wasRecentlyOnline && !user.isOnline, 'pending': true}">
                            <div class="img"
                                 :class="{'is-deleted': !!user.deleted_at}"
                                 :style="!user.deleted_at && {'background': `url(${user.photo_small}) no-repeat center / cover`}">
                            </div>
                            <div class="membership-request"
                                 @click.stop="updateUserMembership(user, 'accept')">
                            </div>
                            <div class="close"
                                 v-if="bang.membership === 'host' && user.id !== bang.user_id && user.membershipStatus === 'member'"
                                 @click.stop="updateUserMembership(user, 'remove')">
                            </div>
                            <div class="details">
                                <div class="name notranslate">{{ user.headline }}</div>
                            </div>
                        </div>
                        <div class="face"
                             v-for="user in members"
                             v-if="user.membershipStatus !== 'requested' && user.id != bang.user_id"
                             @click="openUser(user)"
                             :class="{'host': ((bang.membership === 'host' && user.id === bang.user_id) || user.membershipStatus === 'host'),  'meet_now': user.meet_now, 'online': user.isOnline, 'was-online': user.wasRecentlyOnline && !user.isOnline, 'pending': user.membershipStatus === 'requested'}">
                              <div class="img"
                                  :class="{'is-deleted': !!user.deleted_at}"
                                  :style="!user.deleted_at && {'background': `url(${user.photo_small}) no-repeat center / cover`}">
                              </div>
                              <div class="membership-request" v-if="user.membershipStatus === 'requested'"
                                   @click.stop="updateUserMembership(user, 'accept')">
                              </div>
                              <div class="close"
                                   v-if="bang.membership === 'host' && user.id !== bang.user_id && user.membershipStatus === 'member'"
                                   @click.stop="updateUserMembership(user, 'remove')">
                              </div>
                              <div class="details">
                                  <div class="name notranslate">{{ user.headline }}</div>
                              </div>
                          </div>
                    </div>
                </div>
                <infinite-loading
                    :force-use-infinite-wrapper="isMobile ? '.page-bang' : '#event-details'"
                    ref="infiniteLoadingBangMembers"
                    direction="bottom"
                    @infinite="loadBangMembers"
                    spinner="bubbles">
                              <span slot="no-more"></span>
                              <span slot="no-results"></span>
                </infinite-loading>
                <transition name="slide-in-fwd-center">
                    <div id="event-location-map" class="event-location-map"
                        v-if="locationPreviewVisible"
                        v-on:hide-alert="locationPreviewVisible = false">
                        <Map
                            :lat="bang.lat"
                            :lng="bang.lng"
                            :zoom="15"
                            styles="height: 260px; width: 100%;"
                            :clickable="true"
                            :draggable="false"
                        />
                    </div>
                </transition>

            </div>
            <transition name="fade">
              <div v-show="showScrollTop" class="scroll_top-button"
                   @click="scrollToTop()" :title="trans('arrow_scroll_top')">
                <svg class="icon icon-arrow_up">
                  <use v-bind:xlink:href="symbolsSvgUrl('icon-arrow_up')"></use>
                </svg>
              </div>
            </transition>
            <div class="func-buttons bang">
                    <div id="show-map" class="map"
                         v-if="['host', 'member'].includes(bang.membership)"
                         @click="openMap">
                    </div>
                    <div class="send-message"
                         v-if="['host', 'member'].includes(bang.membership)"
                         v-on:click="startGroupConversation(bang.id, true, bang.conversation_id)"
                         :class="{'notificated': bang.unreadMessagesCount}">
                    </div>
                    <div class="like notranslate"
                         v-if="!bang.is_private && bang.membershipStatus !== 'invited'"
                         :class="{'liked': bang.isLiked}"
                         v-on:click="addLike(bang)">
                        <span v-if="bang.likes">{{ bang.likes }}</span>
                    </div>
                    <div v-if="bang.is_private" class="is-private-block">
                      <svg width="20" height="27" viewBox="0 0 20 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.5 9H16.25V6.5C16.25 3.05 13.45 0.25 10 0.25C6.55 0.25 3.75 3.05 3.75 6.5V9H2.5C1.125 9 0 10.125 0 11.5V24C0 25.375 1.125 26.5 2.5 26.5H17.5C18.875 26.5 20 25.375 20 24V11.5C20 10.125 18.875 9 17.5 9ZM10 20.25C8.625 20.25 7.5 19.125 7.5 17.75C7.5 16.375 8.625 15.25 10 15.25C11.375 15.25 12.5 16.375 12.5 17.75C12.5 19.125 11.375 20.25 10 20.25ZM6.25 9V6.5C6.25 4.425 7.925 2.75 10 2.75C12.075 2.75 13.75 4.425 13.75 6.5V9H6.25Z" fill="#9D9D9D"/>
                      </svg>
                    </div>
                    <strong v-if="bang.membershipStatus === 'invited'" class="invited-text">You have been invited!</strong>
                    <div :class="{buttons:true, notranslate:true, twoButtons:bang.membershipStatus === 'invited'}">
                      <button type="button"
                              class="btn"
                              v-if="!isMyEvent(bang) && !(bang.membershipStatus === 'invited')"
                              @click="updateMembership({ eventId: eventIdComputed })"
                              :disabled="membershipActionDisabled"
                      >{{ membershipActionText }}</button>
                      <button type="button"
                              class="btn darker"
                              v-if="bang.membershipStatus === 'invited'"
                              @click="declineInvite({ eventId: eventIdComputed })"
                              :disabled="membershipActionDisabled"
                      >{{ trans('events.decline') }}</button>
                      <button type="button"
                              class="btn"
                              v-if="bang.membershipStatus === 'invited'"
                              @click="acceptInvite({ eventId: eventIdComputed })"
                              :disabled="membershipActionDisabled"
                      >{{ trans('events.accept') }}</button>
                        <button type="button"
                                v-if="isMyEvent(bang)"
                                @click="editEvent(bang.id, 'bang')"
                                class="edit-button btn">
                            {{ trans('edit') }}
                        </button>
                    </div>
                </div>
        </div>

      <vue-custom-scrollbar :class="{'opened': inviteBlockOpened, 'favourites-list': true}">
        <div class="invite-menu">
          <div class="title">Invite favourite buddies</div>
          <div class="close" @click="closeInviteBlock"></div>
          <div class="wrapper">
            <div class="inner">
              <div class="sharing-block">
                <div class="faces">
                    <div class="face"
                        v-for="(user, index) in favorites"
                        v-if="!invitedUsers.filter(user => user.membershipStatus === 'invited').map(invitedUser => invitedUser.id).includes(user.id) && user.id != bang.user_id"
                        @click="selectUser(user.id, index, user.active)"
                        :class="{'selected': user.active}">
                        <div class="img"
                            :class="{'is-deleted': !!user.deleted_at}"
                            :style="!user.deleted_at && {'background': `url(${user.photo_small}) no-repeat center / cover`}">
                        </div>
                        <div class="details">
                            <div class="name notranslate">{{ user.headline }}</div>
                        </div>
                    </div>
                </div>
              <infinite-loading
                  ref="infiniteLoadingFavorites"
                  v-if="inviteBlockOpened"
                  @infinite="getFavorites"
                  spinner="bubbles"
                  direction="bottom">
                <span slot="no-results" v-if="false">Favorites not exists</span>
                <span slot="no-more" v-if="false">No more favorites</span>
              </infinite-loading>
              </div>
            </div>
          </div>
        </div>
      </vue-custom-scrollbar>

      <div class="inviteButtons" v-if="selectedMembers.length > 0 && inviteBlockOpened" @click="handleInvites()">
        <button class="inviteButton btn" type="button">
          {{ trans('events.invite') }}
        </button>
      </div>

    </span>
</template>

<script>
    import eventsModule from '@events/module/store/type';
    import Map from '@buddy/views/widgets/Map.vue';
    import Alert from '@buddy/views/widgets/Alert.vue';
    import EditEvent from '@events/views/desktop/event/Edit.vue';

    // custom scrollbar
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"
    import {mapActions, mapGetters, mapState} from "vuex";
    import axios from "axios";
    import auth from '@general/lib/auth';

    export default {
        mixins: [
	        require('@general/lib/mixin').default,
          require('@general/lib/mixin-events').default,
	        require('@general/lib/mixin-bang').default,
	        require('@general/lib/mixin-chat').default,
		],
        props: ['eventId'],
        components: {
            Alert,
            Map,
            EditEvent,
            vueCustomScrollbar
        },
        data: () => ({
            locationPreviewVisible: false,
            inviteBlockOpened: false,
            selectedMembers:[],
            showScrollTop: false,
        }),
        computed: {
              ...mapGetters({
                bangData: eventsModule.getters.bang,
                favorites : "favorites",
                favoritesPage: "getFavoritesPage"
              }),
            ...mapState({
                profile: 'profile',
                blockedUsersIds: state => state.blockedUsersIds,
            }),
            invitedUsers() {
              if(this.bang.invitedMembers){
                return this.bang.invitedMembers.filter(member => this.bang.membership !== 'host' || !this.blockedUsersIds.includes(member.id))
              }else{
                return [];
              }
            },
            eventIdComputed(){
                let eventId = this.eventId || this.bangData.eventId
                console.log('[Bang Item] eventIdComputed', { eventId })
                return eventId
            },
            bang(){
              return this.$store.getters.getEvent(this.eventIdComputed)
            },
            members() {
              if(this.bang.members){
                return this.bang.members;
              }else{
                return [];
              }
            },
            membersCount() {
                return this.members.length
            },
        },
      created() {
          app.$on('open-event', this.openEvent)
          this.reset();
      },
      methods: {
            ...mapActions({
              inviteBuddies: 'inviteBuddies',
              getFavorites: "getFavorites"
            }),
            addLike(bang){
              if(this.showJoinModalIfNeed()){
                return false;
              }
              this.toggleEventLike(bang);
            },
            checkScrollDebounce: _.debounce(function (event) {
              if (event) {
                let currentScroll = event.target.scrollTop;
                this.showScrollTop = currentScroll >= 370;
              }
            }, 100),
            scrollToTop() {
              var container;
              if(this.isMobile){
                let y = document.getElementsByClassName('page-bang');
                container = y[0];
              }else{
                container = document.getElementById('event-details');
              }
              container.scrollTo({
                top: 0,
              })
            },
           reset(){
                this.$store.dispatch(eventsModule.actions.events.updateMembers, {
                  event_id: this.bang.id,
                  members: []
                })
                this.$store.dispatch(eventsModule.actions.events.updateInvitedMembers, {
                  event_id: this.bang.id,
                  members: []
                })
                this.$store.commit(eventsModule.mutations.events.setPageMembersNum, 0);
            },
            async loadBangMembers(infiniteScroll) {
              console.log('[Bang Item] load bang members started')
              let self = this;
              let datesCount = await self.$store.dispatch(eventsModule.actions.events.loadMembers, self.bang)

              infiniteScroll.loaded()
              if (datesCount) {
                infiniteScroll.complete()
              }
            },
            deleteInvitation(data){
              this.deleteEventInvitation(data);
              this.$store.dispatch(eventsModule.actions.events.updateInvitedMembers,
                  {
                    event_id: this.bang.id,
                    members: this.invitedUsers.filter(member => member.id !== data.user_id)
                  }
              )
            },
            declineInvite(data) {
              this.declineEventInvitation(data);
              this.showSuccessNotification('Invitation successfully declined')
              this.closeBang();
              this.$store.dispatch('loadCurrentUserInfo');
              setTimeout(function(){
                app.$emit('reload-events')
              }, 750)
            },
            acceptInvite(data) {
              let self = this;
              let callback = function (){
                self.showSuccessNotification('Invitation successfully accepted')
                self.$store.dispatch('loadCurrentUserInfo').then(() => {
                  setTimeout(function(){
                    app.$emit('reload-events')
                  }, 300)
                  setTimeout(function(){
                    app.$emit('open-event', data.eventId, 'bang')
                  }, 700)
                });
              }
              this.acceptEventInvitation(data, callback);
            },
            async handleInvites() {
              let data = {
                selectedMembers: this.selectedMembers,
                eventIdComputed: this.eventIdComputed,
              }
              await this.inviteBuddies(data);
              this.closeInviteBlock();
              this.reset();
              if (this.$refs.infiniteLoadingBangMembers) {
                this.$refs.infiniteLoadingBangMembers.stateChanger.reset();
              }
              this.selectedMembers = [];
              this.favorites.map(function (user) {
                user.active = false;
              })
              this.showSuccessNotification('Users successfully invited');
            },
            selectUser(userId, index, userActive) {
              if (!userId) {
                return;
              }

              let currentMember = this.favorites[index]
              let allMembers = this.favorites

              currentMember.active = !currentMember.active

              if (currentMember.active) {
                this.selectedMembers.push(userId)
              } else {
                this.selectedMembers.splice(_.findIndex(this.selectedMembers, userId), 1)
              }

              this.$set(allMembers, index, currentMember)
            },
            openPrivateInvite() {
              //if (!this.favorites.length) {
              //  this.showErrorNotification(this.trans('events.please_add_favourite_buddies_first'));
             // } else {
                this.inviteBlockOpened = true;

              this.$nextTick(() => {
                if (this.$refs.infiniteLoadingFavorites && this.favoritesPage === 1) {
                  this.$refs.infiniteLoadingFavorites.stateChanger.reset();
                }
              });
             // }
            },
            closeInviteBlock() {
              this.inviteBlockOpened = false;
            },
            async openUser(user){
                let validUser = await this.$store.dispatch('loadUserInfo', user.id)
                if (!validUser) return

                if(validUser.error){
                  this.showNotification({message: validUser.error}, 'error')
                  return false
                }

                if (user.deleted_at) {
                    this.showErrorNotification('profile_is_deleted')
                } else {
                    let userToken = user.handle || user.id
                    if (this.isMobile) {
                        this.goTo('/user/' + userToken)
                        // this.openUserMobileModal(userToken);
                    } else {
                        this.openUserModal(userToken)
                    }
                }
            },
            openMap() {
              this.locationPreviewVisible = !this.locationPreviewVisible

              if (this.locationPreviewVisible) {
                  this.$nextTick(() => {
                    if (this.isMobile) {
                      document.getElementById('event-location-map').scrollIntoView();
                    } else {
                      const scrollDiv = document.getElementById('event-details');
                      const mapBox = document.getElementById('event-location-map');
                      const coordinates = scrollDiv.scrollHeight - mapBox.offsetHeight;

                      scrollDiv.scroll({
                        top: coordinates,
                      });
                    }
                  });
              }
            },
        },
        beforeMount() {
        },
      watch:{
        eventIdComputed(value){
          console.log('eventIdComputed',value)
        }
      },
      activated() {
          console.log('[Bang Item] Activated',
          this.$refs.infiniteLoadingBangMembers)
          if(!app.isDesktop){
            this.reset();
            this.$refs.infiniteLoadingBangMembers.stateChanger.reset();
          }
      },
      mounted() {
            console.log('[Bang Item] Mounted', {
                eventId: this.eventIdComputed,
                bang: this.bang
            })
            var container;
            if(this.isMobile){
              let y = document.getElementsByClassName('page-bang');
              container = y[0];
            }else{
              container = document.getElementById('event-details');
            }
            if (container) {
              container.addEventListener('scroll', this.checkScrollDebounce, true);
            }
            if (!!parseInt(this.eventIdComputed)){
                this.$store.dispatch(eventsModule.actions.membership.remove, this.eventIdComputed)
                this.$store.commit('updateUser', { has_event_notifications: false })
            }

            if(auth.isAuthenticated() && auth.getUserId() === this.bang.user_id){
              this.$store.commit('setFavorites',[]);
              this.$store.commit('setFavoritesPage', 1);
            }
        },
    }
</script>
